var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"editor-group-toggle"},[_c('CollapseToggle',{attrs:{"target":_vm.target,"collapsed":_vm.collapsed}}),_vm._v(" "),_c('h3',{staticClass:"text-center"},[_vm._v(_vm._s(_vm.label))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }